import React from 'react';
import Box from '@/Atoms/Box';
import Card from '@/Atoms/Card';
import CCText from '@/Atoms/CCText';
import {styles} from '../../styles';
import {commentAccentColor} from '../../utils/studyHelpers';

type CurrentMoveCardProps = {
  comment: string;
};

// Workbook panel's Moves tab: the current move's comment, right above the
// move list, under the search bar. Read-only display only - authoring it
// (role, success/hint/wrong-move fields, or a plain comment) lives in the
// school-icon popover (LessonPopover), so this only ever renders for a
// participant, and only when there's something to show.
function CurrentMoveCard({comment}: CurrentMoveCardProps) {
  return (
    <Card style={{width: '100%'}} padding={10}>
      <Box style={styles.commentCardHeader}>
        <CCText style={styles.commentCardLabel}>Comment</CCText>
      </Box>
      <CCText
        fontSize={12.5}
        style={{
          fontStyle: 'italic',
          color: commentAccentColor(comment),
          lineHeight: 18,
        }}>
        {comment}
      </CCText>
    </Card>
  );
}

export default CurrentMoveCard;
